import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Undertittel } from "nav-frontend-typografi";
import Lenke from "nav-frontend-lenker";
import { Feiloppsummering } from "./../../";
export const _frontmatter = {
  "ingress": "Feiloppsummering skal brukes til å gi enkel oversikt over alle feil i et skjema."
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}></ol></nav>
    <p>{`Komponenten skal vises nederst i skjema, men over submit-knappen.`}</p>
    <Example mdxType="Example">
  <Feiloppsummering tittel="For å gå videre må du rette opp følgende:" feil={[{
        skjemaelementId: "1",
        feilmelding: "Du må oppgi et navn"
      }, {
        skjemaelementId: "2",
        feilmelding: "Du må oppgi en adresse"
      }, {
        skjemaelementId: "3",
        feilmelding: "Du må oppgi et telefonnummer"
      }]} mdxType="Feiloppsummering" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`<Feiloppsummering
  tittel="For å gå videre må du rette opp følgende:"
  feil={[
    { skjemaelementId: "1", feilmelding: "Du må oppgi et navn" },
    { skjemaelementId: "2", feilmelding: "Du må oppgi en adresse" },
    { skjemaelementId: "3", feilmelding: "Du må oppgi et telefonnummer" },
  ]}
/>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      